import * as React from 'react';
import { CategoryData } from '../App';
import CategoryPage from './CategoryPage2';
import { ScrollToTop } from '../components/ScrollToTop';
import { Redirect, Route, RouteComponentProps, Switch } from 'react-router-dom';
import { logConfig, WebsiteLogger } from '@prezi/client-logger-module';

import { isDevelopmentEnv } from '../utils';

export interface PreziData {
    can_reuse?: boolean;
    categories: Array<string>;
    description: string;
    element_id: string;
    landing_url: string;
    name: string;
    oid: string;
    owner_name: string;
    thumbnail_url: string;
    title: string;
}
export interface AppProps {
    categories: Array<CategoryData>;
    prezis: Array<PreziData>;
    categoryString: string;
    headerColor?: string;
    activeGalleryTab?: string;
    presentationsTabString?: string;
    videosTabString?: string;
    designTabString?: string;
    isUseAsTemplateFlowActive: boolean;
    templateFlowPageTitleString: string;
}

interface RedirectMatchParams {
    url: string;
}

// TODO proper basepath
export const CATEGORY_ALL_SLUG = '/';
const basePathRegex = '/([a-z][a-z])?/:cms?/:main/';

export class App extends React.Component<AppProps, any> {
    categories: Array<CategoryData>;
    categoryPath: string;
    defaultPath: string;
    categoryLookup: any;
    errors: Array<string>;
    categoryString: string;
    headerColor?: string;
    activeGalleryTab?: string;
    presentationsTabString?: string;
    videosTabString?: string;
    designTabString?: string;

    constructor(props: AppProps) {
        super(props);
        this.errors = [];
        this.categories = this.props.categories;
        this.categoryString = this.props.categoryString;
        this.headerColor = this.props.headerColor;
        this.activeGalleryTab = this.props.activeGalleryTab;
        this.presentationsTabString = this.props.presentationsTabString;
        this.videosTabString = this.props.videosTabString;
        this.designTabString = this.props.designTabString;

        const categoryRegex: string = this.generateSlugRegex(this.categories.map(category => category.slug));
        this.categoryPath = basePathRegex + categoryRegex;
        this.defaultPath = basePathRegex;

        this.categoryLookup = {};
        this.categories.forEach(category => {
            if (this.categoryLookup[category.slug]) {
                this.errors.push(`Duplicate category [${category.slug}] ${category.name}`);
            } else {
                this.categoryLookup[category.slug] = category;
            }
        });

        if (isDevelopmentEnv()) {
            WebsiteLogger.log = console.log;
        } else {
            WebsiteLogger.initLogger(logConfig, '//log.prezi.com/log/json');
        }
    }

    // TODO duplicate
    generateSlugRegex(slugs: Array<string>): string {
        return '(' + slugs.join('|') + ')';
    }

    // TODO duplicate
    buildBasePath(matchParams: {[group: string]: string}): string {
        const lang = matchParams['0'];
        const cms = matchParams['cms'];
        const main = matchParams['main'];

        let basePath = '/';

        if (lang) { basePath += lang + '/'; }
        if (cms) { basePath += cms + '/'; }
        basePath += main + '/';

        return basePath;
    }

    render () {
        return (
            <ScrollToTop>
                <Switch>
                    <Route exact={ true } strict={ true } path="/:url*"
                           render={ (props: RouteComponentProps<RedirectMatchParams>) => <Redirect to={ `${props.location.pathname}/` } /> }
                    />
                    <Route path={this.categoryPath} render={({ match }) => {
                        const currentCategory = this.categoryLookup[match.params[1]];
                        return currentCategory ? (
                            <CategoryPage
                                currentCategory={currentCategory}
                                categories={this.categories}
                                prezis={this.props.prezis}
                                basePath={this.buildBasePath(match.params)}
                                categoryString={this.categoryString}
                                headerColor={this.headerColor}
                                activeGalleryTab={this.activeGalleryTab}
                                presentationsTabString={this.presentationsTabString}
                                videosTabString={this.videosTabString}
                                designTabString={this.designTabString}
                                isUseAsTemplateFlowActive={this.props.isUseAsTemplateFlowActive}
                                templateFlowPageTitleString={this.props.templateFlowPageTitleString}
                            />
                        ): null;
                    }} />
                    <Route path={this.defaultPath} render={({ match }) => {
                        const currentCategory = this.categoryLookup[CATEGORY_ALL_SLUG];
                        return currentCategory ? (
                            <CategoryPage
                                currentCategory={currentCategory}
                                categories={this.categories}
                                prezis={this.props.prezis}
                                basePath={this.buildBasePath(match.params)}
                                categoryString={this.categoryString}
                                headerColor={this.headerColor}
                                activeGalleryTab={this.activeGalleryTab}
                                presentationsTabString={this.presentationsTabString}
                                videosTabString={this.videosTabString}
                                designTabString={ this.designTabString}
                                isUseAsTemplateFlowActive={this.props.isUseAsTemplateFlowActive}
                                templateFlowPageTitleString={this.props.templateFlowPageTitleString}
                            />
                        ): null;
                    }} />
                </Switch>
            </ScrollToTop>
        );
    }
}



// WEBPACK FOOTER //
// ./assets/js/GalleryPage/App.tsx